import { createReducer, on } from '@ngrx/store';
import * as UserActions from './user.actions';

export const userFeatureKey = 'user';
export const userProfileFeatureKey = 'UserProfile';

export interface State {
  users: any[];
  groups: any[];
  userProfile: any[];
}

export const initialState: State = {
  users: [],
  groups: [],
  userProfile: [],
};

export const reducer = createReducer(
  initialState,

  on(UserActions.loadUserSuccess, (state, action) => ({
    ...state,
    users: [...state.users, ...action.users],
  })),

  on(UserActions.addOrUpdateUserProfileSuccess, (state, action) => {
    const updatedState = {
      ...state,
      userProfile: [...state.userProfile, action.userProfile],
    };
    return updatedState;
  }),

  on(UserActions.loadUserProfileSuccess, (state, action) => ({
    ...state,
    userProfile: [...state.userProfile, ...action.userProfile],
  }))
);
